<template lang="pug">
#monitoramento
    BaseHeader(
        titulo='Monitoramento Socioambiental Importação',
        :breadcrumb='breadcrumb',
        icon='el-icon-circle-plus-outline',
        btnTexto='Novo Monitoramento',
        :exibeBotao='false'
    )

    .tabela-monitoramento-cabecario
        .view-container
            span.tabela-monitoramento-cabecario--texto 230 territórios importados com sucesso!

    .tabela-monitoramento-visualizar.view-container
        h3 Selecione o(s) território(s) para iniciar o monitoramento:
        el-table(
            ref='multiplaSelecaoTerritorio',
            :data='listaDados',
            stripe,
            style='width: 100%',
            @selection-change='handleSelecionarRows'
        )
            el-table-column(type='selection', width='55')

            el-table-column(label='Territorios', prop='territorio')
                template(slot-scope='scope')
                    | hhhhhhh

            el-table-column(label='Área', prop='area')
                template(slot-scope='scope')
                    | hhhhhhh

            el-table-column(label='Município', prop='municipio')
                template(slot-scope='scope')
                    | hhhhhhh

            el-table-column(label='Pessoas', prop='representantes')
                template(slot-scope='scope')
                    | hhhhhhh

            el-table-column(label='Car', prop='car')
                template(slot-scope='scope')
                    | hhhhhhh

            el-table-column(label='Ações', prop='acoes')
                template(slot-scope='scope')
                    | hhhhhhh

        .tabela-rodape
            .tabela-rodape-info
                span.tabela-rodape-info--icone
                    i.mdi.mdi-alert-circle-outline
                span.tabela-rodape-info--texto 45 territórios não importados
            .tabela-rodape--botao
                BaseButton.mdi.mdi-play.button-green(type='primary') Iniciar monitoramento

    .tabela-rodape-planilha
        .view-container
            span.tabela-rodape-planilha--texto Baixe a planilha com os erros e o template de tabela para corrigí-los.
            BaseButton.button-green(type='primary') Baixar planilhas para correção
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
export default {
    name: 'ListaTerritoriosImportados',

    components: {
        BaseHeader,
        BaseButton
    },
    props: {},
    data() {
        return {
            breadcrumb: [{ nome: 'Visão geral', rota: '#' }],
            listaDados: [],
            rowSelecionadas: []
        };
    },
    methods: {
        handleSelecionarRows: function (val) {
            this.rowSelecionadas = val;
        }
    }
};
</script>

<style lang="scss">
.tabela-monitoramento-cabecario {
    background: var(--operation-awaiting-approval);
    height: 60px;
    font-size: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    font-weight: 600;
    color: var(--primary);
}

.tabela-monitoramento-visualizar {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }

    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-rodape {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tabela-rodape-info {
            background: var(--disapproved-operation);
            width: 290px;
            height: 45px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-top: 14px;
            justify-content: flex-start;
            border-radius: 5px;
        }

        span.tabela-rodape-info--icone {
            background: #fa4a3b66;
            width: 14%;
            height: 95%;
            border-radius: 5px 0px 0px 5px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        i.mdi.mdi-alert-circle-outline {
            font-size: 24px;
            color: var(--font-danger);
        }

        .tabela-rodape-info--texto {
            font-size: 16px;
            color: var(--font-danger);
            font-weight: 600;
            margin-left: 10px;
        }

        .tabela-rodape--botao {
            margin-top: 14px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }

        .el-button--primary {
            background-color: var(--secondary-two);
            border-color: var(--secondary-two);
            font-size: 16px;
            color: var(--white);
        }

        .el-button--primary:hover {
            background-color: var(--secondary);
            border-color: var(--secondary);
        }
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }
}

.button-green {
    border-color: var(--secondary-two);
    color: var(--white);
    background: var(--secondary-two);
}

.button-green.is-disabled {
    color: var(--white);
    background-color: #80a09e;
    border-color: #80a09e;
}

.tabela-rodape-planilha {
    background: var(--operation-awaiting-approval);
    height: 68px;
    text-align: left;
    font-size: 16px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    color: var(--primary);

    span.tabela-rodape-planilha--texto {
        margin-right: 15px;
    }

    .el-button--primary {
        background-color: var(--secondary-two);
        border-color: var(--secondary-two);
        font-size: 16px;
        color: var(--white);
    }

    .el-button--primary:hover {
        background-color: var(--secondary);
        border-color: var(--secondary);
    }
}
</style>
